var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResumeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m142.468 94.267h66.398v66.399h-66.398z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m360.433 128.533h94.581l-119.747-119.746v94.58c0 13.877 11.29 25.166 25.166 25.166z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m360.433 158.533c-30.418 0-55.166-24.747-55.166-55.166v-103.367h-201.9c-30.419 0-55.167 24.748-55.167 55.167v401.666c0 30.419 24.748 55.167 55.166 55.167h305.268c30.419 0 55.166-24.748 55.166-55.167v-298.3zm-247.965-79.266c0-8.284 6.715-15 15-15h96.398c8.285 0 15 6.716 15 15v96.399c0 8.284-6.715 15-15 15h-96.398c-8.285 0-15-6.716-15-15zm15 145.667h192.799c8.285 0 15 6.716 15 15s-6.715 15-15 15h-192.799c-8.285 0-15-6.716-15-15 0-8.285 6.715-15 15-15zm257.066 222.798h-257.066c-8.285 0-15-6.716-15-15s6.715-15 15-15h257.066c8.283 0 15 6.716 15 15 0 8.285-6.717 15-15 15zm0-64.265h-257.066c-8.285 0-15-6.716-15-15s6.715-15 15-15h257.066c8.283 0 15 6.716 15 15s-6.717 15-15 15zm0-64.268h-257.066c-8.285 0-15-6.716-15-15s6.715-15 15-15h257.066c8.283 0 15 6.716 15 15s-6.717 15-15 15z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIcon);
export default __webpack_public_path__ + "static/media/resume-icon.f7b8ac40794e7e09a989c05e94389e9e.svg";
export { ForwardRef as ReactComponent };